'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactTextInput = require('react-text-input');

var _reactTextInput2 = _interopRequireDefault(_reactTextInput);

var _aphrodite = require('aphrodite');

var _localizer = require('../util/localizer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STYLES = _aphrodite.StyleSheet.create({
	typeWrapper: {
		margin: '10px 0 0',
		position: 'relative'
	},
	errorMessage: {
		transition: 'all 0.25s ease-in-out'
	},
	dropdown: {
		padding: 0,
		textIndent: 12,
		boxSizing: 'content-box',
		appearance: 'none'
	},
	arrow: {
		position: 'absolute',
		right: 10,
		top: '50%',
		cursor: 'default',
		pointerEvents: 'none'
	},
	arrowError: {
		marginTop: -17
	},
	errorStyles: {
		height: '100%'
	}
}); /**
     * NationalId component used to get the user's national ID type and value
     * - used with account creation and can be a hidden input
     */

var NationalId = _react2.default.createClass({
	displayName: 'NationalId',

	propTypes: {
		country: _react.PropTypes.string,
		labelNationalIdType: _react.PropTypes.string,
		labelNationalIdNumber: _react.PropTypes.string,
		helpText: _react.PropTypes.string,
		showErrorMessages: _react.PropTypes.bool,
		value: _react.PropTypes.string,
		errorMessageType: _react.PropTypes.string,
		errorMessageNumber: _react.PropTypes.string,
		defaultIdType: _react.PropTypes.string,
		nationalIds: _react.PropTypes.array,
		changeEmail: _react.PropTypes.func,
		handleFocus: _react.PropTypes.func,
		handleBlur: _react.PropTypes.func,
		resetNationalId: _react.PropTypes.func,
		validNationalIdType: _react.PropTypes.func,
		validNationalIdNumber: _react.PropTypes.func
	},

	getDefaultProps: function getDefaultProps() {
		return {
			showErrorMessages: true,
			handleFocus: function handleFocus() {},
			handleBlur: function handleBlur() {},
			resetNationalId: function resetNationalId() {},
			validNationalIdType: function validNationalIdType() {},
			validNationalIdNumber: function validNationalIdNumber() {}
		};
	},
	getInitialState: function getInitialState() {
		return {
			idType: this.props.defaultIdType
		};
	},


	/**
  * Call parent's handleFocus
  * @param {String} nationalIdNumber - national ID number
  */
	handleFocus: function handleFocus(nationalIdNumber) {
		this.props.handleFocus(nationalIdNumber);
	},


	/**
  * Call parent's handleBlur
  * @param {String} nationalIdNumber - national ID number
  */
	handleBlur: function handleBlur(nationalIdNumber) {
		this.props.handleBlur(nationalIdNumber);
	},


	/**
  * handleChangeNationalIdType
  * @param {String} nationalIdType - national ID type
  */
	handleChangeNationalIdType: function handleChangeNationalIdType(event) {
		var nationalIdType = event.target.value;
		this.setState({ nationalIdType: nationalIdType });
		if (nationalIdType) {
			this.props.validNationalIdType(nationalIdType);
		} else {
			this.props.resetNationalId();
		}
		return nationalIdType;
	},


	/**
  * Call parent's handleFocus
  * @param {String} nationalIdNumber - national ID number
  */
	handleChangeNationalNumber: function handleChangeNationalNumber(nationalIdNumber) {
		this.setState({ nationalIdNumber: nationalIdNumber });
		if (nationalIdNumber) {
			this.props.validNationalIdNumber(nationalIdNumber);
		} else {
			this.props.resetNationalId();
		}
		return nationalIdNumber;
	},
	render: function render() {
		var _this = this;

		var countryInfo = (0, _localizer.getCountryInfo)(this.props.country);
		var _props = this.props,
		    initialValue = _props.value,
		    errorMessageType = _props.errorMessageType,
		    errorMessageNumber = _props.errorMessageNumber,
		    showErrorMessages = _props.showErrorMessages;


		var arrowClassNames = (0, _classnames2.default)((0, _aphrodite.css)(STYLES.arrow), showErrorMessages && errorMessageType && (0, _aphrodite.css)(STYLES.arrowError), {
			'icon icon-arrow-down-small': true
		});

		var typeWrapperClassNames = (0, _classnames2.default)((0, _aphrodite.css)(STYLES.typeWrapper), {
			'vx_has-error-with-message vx_has-error': errorMessageType
		});

		// define the wrapper classNames, which handle showing error messages
		var numberWrapperClassNames = (0, _classnames2.default)((0, _aphrodite.css)(STYLES.typeWrapper), {
			'vx_has-error-with-message vx_has-error': errorMessageNumber
		});

		// define the wrapper classNames, which handle showing error messages
		var errorMessageClassNames = (0, _classnames2.default)((0, _aphrodite.css)(STYLES.errorStyles), {
			'vx_form-control-message': true
		});

		// Getting natiponal id's from props or from localizer
		var nationalIds = this.props.nationalIds || countryInfo.nationalIds;

		return _react2.default.createElement(
			'div',
			null,
			countryInfo.showNationalId && _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'div',
					{ className: typeWrapperClassNames },
					_react2.default.createElement(
						'select',
						{
							name: 'nationalIdType',
							id: 'nationalIdType',
							className: 'vx_form-control ' + (0, _aphrodite.css)(STYLES.dropdown),
							defaultValue: this.state.idType,
							onChange: function onChange(value) {
								return _this.handleChangeNationalIdType(value);
							},
							style: STYLES.dropdown },
						_react2.default.createElement(
							'option',
							{ value: '', disabled: true },
							this.props.labelNationalIdType
						),
						nationalIds.map(function (item) {
							return _react2.default.createElement(
								'option',
								{ key: item.label, value: item.value },
								item.label
							);
						})
					),
					_react2.default.createElement('label', { htmlFor: 'nationalIdType', className: arrowClassNames }),
					errorMessageType && showErrorMessages && _react2.default.createElement(
						'div',
						{ className: errorMessageClassNames },
						errorMessageType
					)
				),
				_react2.default.createElement(
					'div',
					{ className: numberWrapperClassNames, style: { margin: '10px 0 0', position: 'relative' } },
					_react2.default.createElement(_reactTextInput2.default, {
						type: 'text',
						name: 'nationalIdNumber',
						id: 'nationalIdNumber',
						className: 'vx_form-control vx_form-control_complex',
						label: this.props.labelNationalIdNumber,
						helpText: this.props.labelNationalIdNumber,
						required: true,
						value: initialValue,
						errorMessage: this.props.errorMessageNumber,
						handleChange: this.handleChangeNationalNumber,
						handleFocus: this.handleFocus,
						handleBlur: this.handleBlur
					}),
					errorMessageNumber && showErrorMessages && _react2.default.createElement(
						'div',
						{ className: errorMessageClassNames },
						errorMessageNumber
					)
				)
			)
		);
	}
});

exports.default = NationalId;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/guest-payment/dist/components/NationalId.js
// module id = 403
// module chunks = 6